import { appRoutePaths } from '../services/route.service';

export interface NavigationTabItem {
  name: string;
  routePath: string;
}

export const Tabs_MDE_OTSS = [
  {
    name: 'Course Codes',
    routePath: appRoutePaths.CourseCodeList,
  },
  {
    name: 'SEA Organizations',
    routePath: appRoutePaths.SeaOrganizationList,
  },
];

export const Tabs_DISTRICT_SCHOOL = [
  {
    name: 'LEA Management',
    routePath: appRoutePaths.LEAManagementList,
  },
  {
    name: 'School Management',
    routePath: appRoutePaths.SchoolManagementList,
  },
  {
    name: 'LEA Sharing',
    routePath: appRoutePaths.LEASharingList,
  },
  {
    name: 'Salary Scale',
    routePath: appRoutePaths.SalaryScaleList,
  },
  {
    name: 'Board Members',
    routePath: appRoutePaths.BoardMembersList,
  },
  {
    name: 'Dyslexia Screening & Training',
    routePath: appRoutePaths.DyslexiaScreenerList(),
  },
  {
    name: 'Literacy Screening',
    routePath: appRoutePaths.LiteracyScreeningList,
  },
  {
    name: 'Neglected or Delinquent',
    routePath: appRoutePaths.NeglectedOrDelinquentList,
  },
];

export const Tabs_STUDENT = [
  {
    name: 'Student Intervention',
    routePath: appRoutePaths.StudentInterventionList,
  },
  {
    name: 'Non Public Student',
    routePath: appRoutePaths.NonPublicStudentEntryList,
  },
  {
    name: 'Summer Activity',
    routePath: appRoutePaths.SummerActivityList,
  },
  {
    name: 'Update Grades and Promotions',
    routePath: appRoutePaths.GradesAndPromotionsList,
  },
  {
    name: 'Exit Adjustment',
    routePath: appRoutePaths.ExitAdjustmentList,
  },
  {
    name: 'Senior Snapshot',
    routePath: appRoutePaths.SeniorSnapshotList,
  },
  {
    name: 'Seal of Biliteracy',
    routePath: appRoutePaths.SealOfBiliteracyList(),
  },
];
